import { lazy } from 'react';

const AgOperationContainer = lazy(() =>
  import('./pages/ag-operation/ag-operation.container').then((m) => ({
    default: m.AgOperationContainer,
  })),
);
const AgOperationCreateContainer = lazy(() =>
  import('./pages/ag-operation-create/ag-operation-create.container').then(
    (m) => ({
      default: m.AgOperationCreateContainer,
    }),
  ),
);
const AuthContainer = lazy(() =>
  import('./auth/auth.container').then((m) => ({
    default: m.AuthContainer,
  })),
);
const CommercializationContractsContainer = lazy(() =>
  import(
    './pages/commercialization/commercialization-contracts/commercialization-contracts.container'
  ).then((m) => ({
    default: m.CommercializationContractsContainer,
  })),
);
const CommercializationStockContainer = lazy(() =>
  import(
    './pages/commercialization/commercialization-stock/commercialization-stock.container'
  ).then((m) => ({
    default: m.CommercializationStockContainer,
  })),
);
const CommercializationMovementsContainer = lazy(() =>
  import(
    './pages/commercialization/commercialization-movements/commercialization-movements.container'
  ).then((m) => ({
    default: m.CommercializationMovementsContainer,
  })),
);
const DashboardContainer = lazy(() =>
  import('./pages/dashboard/dashboard.container').then((m) => ({
    default: m.DashboardContainer,
  })),
);
const FinancialContainer = lazy(() =>
  import(
    './pages/financial/financial-overview/financial-overview.container'
  ).then((m) => ({ default: m.FinancialContainer })),
);
const FinancialProductionContainer = lazy(() =>
  import(
    './pages/financial/financial-production/financial-production.container'
  ).then((m) => ({ default: m.FinancialProductionContainer })),
);
const FinancialBudgetContainer = lazy(() =>
  import('./pages/financial/financial-budget/financial-budget.container').then(
    (m) => ({ default: m.FinancialBudgetContainer }),
  ),
);
const SeasonBudgetContainer = lazy(() =>
  import('./pages/financial/season-budget/season-budget.container').then(
    (m) => ({ default: m.SeasonBudgetContainer }),
  ),
);
const FinancialMachineryContainer = lazy(() =>
  import(
    './pages/financial/financial-machinery/financial-machinery.container'
  ).then((m) => ({ default: m.FinancialMachineryContainer })),
);
const HelpCenterContainer = lazy(() =>
  import('./pages/help-center/help-center.container').then((m) => ({
    default: m.HelpCenterContainer,
  })),
);
const HomeContainer = lazy(() =>
  import('./pages/home/home.container').then((m) => ({
    default: m.HomeContainer,
  })),
);
const MaintenanceContainer = lazy(() =>
  import('./pages/maintenance/maintenance.container').then((m) => ({
    default: m.MaintenanceContainer,
  })),
);
const MaterialConsumptionListContainer = lazy(
  () =>
    import('./pages/material-consumption/material-consumption-list.container'),
);
const MigrationContainer = lazy(() =>
  import('./pages/migration/migration.container').then((m) => ({
    default: m.MigrationContainer,
  })),
);
const MyCropwiseContainer = lazy(() =>
  import('./pages/my-cropwise/my-cropwise.container').then((m) => ({
    default: m.MyCropwiseContainer,
  })),
);
const InvoiceListContainer = lazy(() =>
  import('./pages/orders-and-payments/invoice/invoice-list.container').then(
    (m) => ({
      default: m.InvoiceListContainer,
    }),
  ),
);
const PurchaseListContainer = lazy(() =>
  import('./pages/orders-and-payments/purchase/purchase-list.container').then(
    (m) => ({ default: m.PurchaseListContainer }),
  ),
);
const AccountsPayableContainer = lazy(() =>
  import(
    './pages/orders-and-payments/accounts-payable/accounts-payable.container'
  ).then((m) => ({ default: m.AccountsPayableContainer })),
);
const ElectronicInvoiceContainer = lazy(() =>
  import(
    './pages/orders-and-payments/electronic-invoice/electronic-invoice.container'
  ).then((m) => ({ default: m.ElectronicInvoiceContainer })),
);
const ElectronicInvoiceLinkContainer = lazy(() =>
  import(
    './pages/orders-and-payments/electronic-invoice/electronic-invoice-link/electronic-invoice-link.container'
  ).then((m) => ({ default: m.ElectronicInvoiceLinkContainer })),
);
const NoOrganization = lazy(() =>
  import('./pages/organization/no-organization/no-organization.component').then(
    (m) => ({ default: m.NoOrganization }),
  ),
);
const NoPermission = lazy(() =>
  import('./pages/organization/no-permission/no-permission.component').then(
    (m) => ({
      default: m.NoPermission,
    }),
  ),
);
const NoPermissionBalance = lazy(() =>
  import(
    './pages/organization/no-permission-balance/no-permission-balance.component'
  ).then((m) => ({ default: m.NoPermissionBalance })),
);
const ReportGeneralLedger = lazy(() =>
  import(
    './pages/report-general-ledger/report-general-ledger-list.container'
  ).then((m) => ({ default: m.ReportGeneralLedgerContainer })),
);
const DataImportDetailsContainer = lazy(() =>
  import(
    './pages/reports/data-import/data-import-details/data-import-details.container'
  ).then((m) => ({ default: m.DataImportDetailsContainer })),
);
const DataImportListContainer = lazy(() =>
  import(
    './pages/reports/data-import/data-import-list/data-import-list.container'
  ).then((m) => ({ default: m.DataImportListContainer })),
);
const DataImportStartContainer = lazy(() =>
  import(
    './pages/reports/data-import/data-import-start/data-import-start.container'
  ).then((m) => ({ default: m.DataImportStartContainer })),
);
const ReportsContainer = lazy(
  () => import('./pages/reports/reports.container'),
);
const ItemCategoryContainer = lazy(() =>
  import('./pages/resources/item-category/item-category.container').then(
    (m) => ({
      default: m.ItemCategoryContainer,
    }),
  ),
);
const SupplierList = lazy(() =>
  import('./pages/resources/supplier/supplier-list.container').then((m) => ({
    default: m.SupplierListContainer,
  })),
);
const BankAccountListContainer = lazy(() =>
  import('./pages/resources/bank-account/bank-account-list.container').then(
    (m) => ({
      default: m.BankAccountListContainer,
    }),
  ),
);
const ImportContainer = lazy(() =>
  import('./pages/resources/import/import.container').then((m) => ({
    default: m.ImportContainer,
  })),
);
const ItemListContainer = lazy(() =>
  import('./pages/resources/item/item-list.container').then((m) => ({
    default: m.ItemListContainer,
  })),
);
const MachineryListContainer = lazy(() =>
  import('./pages/resources/machinery/machinery-list.container').then((m) => ({
    default: m.MachineryListContainer,
  })),
);
const NoCostRecordsContainer = lazy(() =>
  import('./pages/revision/no-cost-records/no-cost-records.component').then(
    (m) => ({
      default: m.NoCostRecordsContainer,
    }),
  ),
);
const BalanceAiListContainer = lazy(() =>
  import(
    './pages/revision/balance-ai/balance-ai-list/balance-ai-list.container'
  ).then((m) => ({ default: m.BalanceAiListContainer })),
);
const BalanceAiTermsAndConditions = lazy(() =>
  import(
    './pages/revision/balance-ai/terms-and-conditions/terms-and-conditions.component'
  ).then((m) => ({ default: m.TermsAndConditions })),
);
const SettingsContainer = lazy(() =>
  import('./pages/settings/settings.container').then((m) => ({
    default: m.SettingsContainer,
  })),
);
const NewMovementsContainer = lazy(() =>
  import('./pages/stock/movements/new-movements.container').then((m) => ({
    default: m.NewMovementsContainer,
  })),
);
const NewStockSummaryContainer = lazy(() =>
  import('./pages/stock/stock-summary/new-stock-summary.container').then(
    (m) => ({
      default: m.NewStockSummaryContainer,
    }),
  ),
);

export {
  AccountsPayableContainer,
  AgOperationContainer,
  AgOperationCreateContainer,
  AuthContainer,
  BalanceAiListContainer,
  BalanceAiTermsAndConditions,
  BankAccountListContainer,
  CommercializationContractsContainer,
  CommercializationMovementsContainer,
  CommercializationStockContainer,
  DashboardContainer,
  DataImportDetailsContainer,
  DataImportListContainer,
  DataImportStartContainer,
  ElectronicInvoiceContainer,
  ElectronicInvoiceLinkContainer,
  FinancialBudgetContainer,
  FinancialContainer,
  FinancialMachineryContainer,
  FinancialProductionContainer,
  HelpCenterContainer,
  HomeContainer,
  ImportContainer,
  InvoiceListContainer,
  ItemCategoryContainer,
  ItemListContainer,
  MachineryListContainer,
  MaintenanceContainer,
  MaterialConsumptionListContainer,
  MigrationContainer,
  MyCropwiseContainer,
  NewMovementsContainer,
  NewStockSummaryContainer,
  NoCostRecordsContainer,
  NoOrganization,
  NoPermission,
  NoPermissionBalance,
  PurchaseListContainer,
  ReportGeneralLedger,
  ReportsContainer,
  SeasonBudgetContainer,
  SettingsContainer,
  SupplierList,
};
